import CardPrezziario from "./CardPrezziario";

function PrezziarioSelector({ prezziari, setPrezziari, emptyPrezziario }) {
  const addNew = () => {
    setPrezziari((current) => [...current, emptyPrezziario]);
  };

  const removeCard = (index) => {
    var tmp = prezziari.filter((item, i) => i != index);
    setPrezziari(tmp);
  };

  const setNGuest = (newValue, index) => {
    const tmp = prezziari.slice();
    tmp[index].tot_guests = newValue;
    setPrezziari(tmp);
  };

  const setBasePrice = (newValue, index) => {
    const tmp = prezziari.slice();
    tmp[index].base_price = newValue;
    setPrezziari(tmp);
  };

  const setChildrenPrice = (newValue, index) => {
    const tmp = prezziari.slice();
    tmp[index].children_price = newValue;
    setPrezziari(tmp);
  };

  const setIsBreakfast = (newValue, index) => {
    const tmp = prezziari.slice();
    tmp[index].breakfast_included = newValue;
    setPrezziari(tmp);
  };

  const setTreatments = (newValue, index) => {
    const tmp = prezziari.slice();
    tmp[index].treatments = newValue;
    setPrezziari(tmp);
  };

  return (
    <>
      {prezziari?.map((prezziario, index) => (
        <CardPrezziario
          key={index}
          prezziario={prezziario}
          setNGuest={(newValue) => setNGuest(newValue, index)}
          setBasePrice={(newValue) => setBasePrice(newValue, index)}
          setChildrenPrice={(newValue) => setChildrenPrice(newValue, index)}
          setIsBreakfast={(newValue) => setIsBreakfast(newValue, index)}
          setTreatments={(newValue) => setTreatments(newValue, index)}
          addNew={addNew}
          removeCard={() => removeCard(index)}
          last={index == prezziari.length - 1}
        />
      ))}
    </>
  );
}

export default PrezziarioSelector;
